import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class VvnPrimaryDialog extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'vvn_primary_dialog.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
